<template>
	<AdminPageLayout :loading="loading" :error="error">
		<table class="generic-table">
			<thead>
				<tr>
					<th>Email</th>
					<th>Tag</th>
					<th>IP Address</th>
					<th>Status</th>
					<th>C2C</th>
					<th>Created</th>
					<th>Actions</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="wireguard in wireguards" :key="wireguard.ipv4">
					<td>{{ wireguard.email }}</td>
					<td>{{ wireguard.tag }}</td>
					<td>
						<div>{{ wireguard.ipv4 }}</div>
						<div>{{ wireguard.ipv6 }}</div>
					</td>
					<td>{{ wireguard.status }}</td>
					<td>
						<input 
							type="checkbox" 
							:checked="wireguard.c2c_enabled"
							disabled
							style="cursor: not-allowed;"
						/>
					</td>
					<td>{{ $formatDate(wireguard.created) }}</td>
					<td>
						<div class="generic-table-actions">
							<button 
								v-if="!wireguard.c2c_enabled"
								@click="enableC2C(wireguard.ipv4)"
								class="generic-table-action-button"
								:disabled="action_loading"
							>
								Enable C2C
							</button>
							<button 
								v-if="wireguard.c2c_enabled"
								@click="disableC2C(wireguard.ipv4)"
								class="generic-table-action-button"
								:disabled="action_loading"
							>
								Disable C2C
							</button>
							<button 
								@click="deleteWireguard(wireguard.ipv4)"
								class="generic-table-action-button"
								:disabled="action_loading"
							>
								Delete
							</button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</AdminPageLayout>
</template>

<script>
import AdminPageLayout from './_PageLayout.vue'

export default {
	name: 'AdminWireguard',
	components: {
		AdminPageLayout
	},
	data() {
		return {
			loading: true,
			action_loading: false,
			error: '',
			wireguards: []
		}
	},
	async mounted() {
		await this.fetchWireguards()
	},
	methods: {
		async fetchWireguards() {
			this.loading = true
			this.error = ''

			const authToken = localStorage.getItem('authToken')?.trim()
			if (!authToken || authToken === 'null') {
				this.$router.push({ name: 'Login' })
				return
			}
			
			try {
				const response = await this.$api.post('/api/admin/wireguard', {
					authToken: authToken
				})
				
				this.wireguards = response.data.wireguards || []
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else {
					this.error = 'An error occurred while loading wireguard configurations.'
					console.error('Error:', error)
				}
			} finally {
				this.loading = false
			}
		},
		async deleteWireguard(ipv4) {
			this.action_loading = true
			this.error = ''
			const authToken = localStorage.getItem('authToken')?.trim()

			try {
				await this.$api.post('/api/admin/wireguard/delete', {
					authToken: authToken,
					ipv4: ipv4
				})
				await this.fetchWireguards()
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else if (error.response && error.response.status === this.$StatusCodes.NOT_FOUND) {
					this.error = 'Wireguard configuration not found.'
				} else {
					this.error = 'An error occurred while deleting wireguard configuration.'
					console.error('Error:', error)
				}
			} finally {
				this.action_loading = false
			}
		},
		async enableC2C(ipv4) {
			this.action_loading = true
			this.error = ''
			const authToken = localStorage.getItem('authToken')?.trim()

			try {
				await this.$api.post('/api/admin/wireguard/c2c/enable', {
					authToken: authToken,
					ipv4: ipv4
				})
				await this.fetchWireguards()
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else if (error.response && error.response.status === this.$StatusCodes.NOT_FOUND) {
					this.error = 'Wireguard configuration not found.'
				} else {
					this.error = 'An error occurred while enabling C2C.'
					console.error('Error:', error)
				}
			} finally {
				this.action_loading = false
			}
		},
		async disableC2C(ipv4) {
			this.action_loading = true
			this.error = ''
			const authToken = localStorage.getItem('authToken')?.trim()

			try {
				await this.$api.post('/api/admin/wireguard/c2c/disable', {
					authToken: authToken,
					ipv4: ipv4
				})
				await this.fetchWireguards()
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else if (error.response && error.response.status === this.$StatusCodes.NOT_FOUND) {
					this.error = 'Wireguard configuration not found.'
				} else {
					this.error = 'An error occurred while disabling C2C.'
					console.error('Error:', error)
				}
			} finally {
				this.action_loading = false
			}
		}
	}
}
</script>

<style scoped>
</style>

